<template>
   <b-modal id="show-payout-details-modal" centered hide-footer no-close-on-backdrop size="xl">
      <template #modal-header>
         <div>
            <h5>{{ $t("account-page-facility-payout.payout_date") }}: {{ formatDateToSlash(data.payout_date) }}</h5>
         </div>
         <button type="button" class="close" @click="$bvModal.hide('show-payout-details-modal')">
            <span aria-hidden="true">&times;</span>
         </button>
      </template>
      <div class="row">
         <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-2">
               <label class="h5">{{ $t("account-page-facility-payout.transactions") }}</label>
               <div class="d-flex">
                  <button 
                     v-if="isDownloadable"
                     type="button"
                     class="btn btn-info mr-2"
                     @click="downloadInvoice(data.id)"
                  >
                     {{ $t("account-page-facility-payout.invoice_button_text") }}
                  </button>
                  <button 
                     v-if="isDownloadable"
                     type="button"
                     class="btn btn-info"
                     @click="download"
                  >
                     {{ $t("account-page-facility-payout.list_button_text") }}
                  </button>
               </div>
            </div>
            <div class="table-responsive table-bordered visitors-table">
               <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
                  <thead>
                     <tr>
                        <th>{{ $t("account-page-facility-payout.captured_date") }}</th>
                        <th>{{ $t("account-page-facility-payout.amount") }} JPY</th>
                        <!-- <th>{{ $t("account-page-facility-payout.fee") }} JPY</th>
                        <th>{{ $t("account-page-facility-payout.net") }} JPY</th> -->
                     </tr>
                  </thead>

                  <tbody>
                     <tr v-for="(value, key) in data.payout_details" :key="key">
                        <td>{{ formatDate(value.capture_date) }}</td>
                        <td>{{ formatAmount(value.amount) }}</td>
                        <!-- <td>{{ formatAmount(value.fee) }}</td>
                        <td>{{ formatAmount(value.net) }}</td> -->
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
   </b-modal>
</template>

<script>
import moment from 'moment';

import formatters from '@/mixins/formatters.js';

export default {
   name: "payoutListDetails",
   data() {
      return {
         payoutHeaderId: '',
         data: [],
         isDownloadable: true,
      };
   },
   methods: {
      async view(data, isDownloadable = true) {
         this.isDownloadable = isDownloadable;
         this.data = data;
         this.payoutHeaderId = data.id;
         this.$bvModal.show("show-payout-details-modal");
      },
      async download() {
         const response = await this.$lionheart
            .get(`v2/payout-details-donwload/${this.payoutHeaderId}`, { responseType: "arraybuffer" })

         const fileName = moment(this.data.payout_date).format("YYYYMMDD");
         const blob = new Blob([response.data], { type: "application/xls" });
         const link = document.createElement("a");
         link.href = window.URL.createObjectURL(blob);
         link.setAttribute("download", `${fileName}_payout_details.xlsx`);
         document.body.appendChild(link);
         link.click();
         link.remove();
      },

      async downloadInvoice(payoutHeaderId) {
         const response = await this.$lionheart
            .get(`v2/dg/download-payout-receipt/${payoutHeaderId}`, { responseType: "arraybuffer" })
         const fileName = moment(this.data.payout_date).format("YYYYMMDD");
         const blob = new Blob([response.data], { type: "application/pdf" });
         const link = document.createElement("a");
         link.href = window.URL.createObjectURL(blob);
         link.setAttribute("download", `${fileName}_payout_invoice.pdf`);
         document.body.appendChild(link);
         link.click();
         link.remove();
      },
   },
   mixins: [formatters],
};
</script>

<style scoped></style>
